import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { generateAva } from '../../utils/fakeAvaGenerator';

export const CategoryAva = memo(({ category }) => {
  const fakeAva = generateAva(category);
  const randomBg = [
    'bg-lime-500',
    'bg-amber-500',
    'bg-green-500',
    'bg-emerald-500',
    'bg-yellow-500',
    'bg-teal-500',
    'bg-sky-500',
    'bg-fuchsia-500',
    'bg-orange-500',
    'bg-red-500',
  ];

  const chosenBg = randomBg[Math.floor(Math.random() * randomBg.length)];

  return (
    <div
      className={clsx(
        'grid h-9 w-9 place-items-center overflow-hidden rounded-full text-lg',
        chosenBg
      )}
    >
      <span className="inline-block">{fakeAva}</span>
    </div>
  );
});

CategoryAva.propTypes = {
  category: PropTypes.string.isRequired,
};
